export default __webpack_public_path__ + "static/media/new_user.be4aa417.svg";